import { render, staticRenderFns } from "./UIBtn.vue?vue&type=template&id=fd438550&scoped=true"
import script from "./UIBtn.vue?vue&type=script&lang=js"
export * from "./UIBtn.vue?vue&type=script&lang=js"
import style0 from "./UIBtn.vue?vue&type=style&index=0&id=fd438550&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd438550",
  null
  
)

export default component.exports